module.exports = __webpack_public_path__ + "static/bg-sec4-14cbb1279f16e5fdb93dc0bd96be32ad.jpg";